import {
  Box,
  TableCell,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";

export const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[900] : "#f5f5f5",
  minHeight: "100vh",
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "16px",
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[800] : "#e8eaed",
  color: theme.palette.text.primary,
}));

export const ButtonGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
  justifyContent: "flex-end", 
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(1.5, 3), 
  fontSize: "14px",
  color: theme.palette.text.primary,
  borderColor: theme.palette.divider,
  textTransform: "none",
  minWidth: "90px",
  height: "38px",
  borderRadius: "8px", 
  "& svg": {
    marginRight: theme.spacing(1),
    fontSize: "20px",
  },
}));

export const SuspendButton = styled(StyledButton)(({ theme }) => ({
  color: "#fff",
  backgroundColor: "#D32F2F", 
  borderColor: "#D32F2F",
  "&:hover": {
    backgroundColor: "#B71C1C",
    borderColor: "#B71C1C",
  },
}));
